module.exports = __webpack_public_path__ + "img/m-center.3daffced.png";